<template>
  <tr>
    <td>{{ aluno }}</td>
    <td>{{ response.hodometro_inicio }} ~ {{ response.hodometro_fim }}</td>
    <td>
      {{ aulas[0].data_aula.slice(0, 10).split('-').reverse().join('/') }}
    </td>
    <td>
      {{ aulas[0].data_aula.slice(11, -3) }}
    </td>
    <td>
      {{ Object.keys(aulas).length > 1 ? new Date(createDate(aulas[1].data_aula).getTime() +
        50 * 60000).toLocaleTimeString('pt-BR').slice(0, 5) : new Date(createDate(aulas[0].data_aula).getTime() +
          50 * 60000).toLocaleTimeString('pt-BR').slice(0, 5) }}
    </td>
    <td>
      <div class="d-flex flex-row align-items-baseline">
        <!-- <span class="mr-3">{{ inicio.slice(0, 10).split('-').reverse().join('/') }}</span> -->
        <input type="time" name="" id="" v-model="newInicio" step="100" class="form-control">
      </div>
    </td>
    <td>
      <div class="d-flex flex-row align-items-baseline">
        <!-- <span class="mr-3">{{ fim.slice(0, 10).split('-').reverse().join('/')}}</span> -->
        <input type="time" name="" id="" v-model="newFim" step="100" class="form-control">
      </div>
    </td>
    <td>
      <strong v-if="Object.keys(aulas).length > 1"><i class="fa fa-check"></i></strong>
    </td>
    <td>
      <strong>{{ aulas[0].status }}</strong>
    </td>
    <td>
      <div class="actions">
        <template v-if="newInicio != originalInicio || newFim != originalFim">
          <div>
            <IconButton @handle:click="atualizarHorario" color="primary" title="Atualizar" :disabled="loadingActions">
              <Check :size="18" />
            </IconButton>
          </div>

          <div>
            <IconButton @handle:click="reverterHorario" color="danger" title="Reverter" :disabled="loadingActions">
              <Close :size="18" />
            </IconButton>
          </div>
        </template>

        <div>
          <IconButton @handle:click="openConfirmMoodal" color="danger" title="Cancelar Aula" :disabled="loadingActions">
            <TrashCanOutline :size="18" />
          </IconButton>
        </div>
      </div>
    </td>

    <ConfirmModal ref="confirmModal" title="Cancelar aula"
      message="Deseja mesmo remover a anotação? A operação é irreversível." :onConfirm="cancelarAula" />
  </tr>
</template>
<script>
import Vue from 'vue'
import urlApi from '@/router/urlApiV2'
import IconButton from 'core/IconButton'
import ConfirmModal from 'core/ConfirmModal'
import Close from 'icons/Close'
import TrashCanOutline from 'icons/TrashCanOutline'
import Check from 'icons/Check'

export default {
  components: {
    IconButton,
    ConfirmModal,
    Close,
    TrashCanOutline,
    Check,
  },
  props: {
    response: Object,
    aulaId: Number,
    aluno: String,
    schema: String,
    inicio: String,
    fim: String,
    aulas: Array,
  },
  data() {
    return {
      originalInicio: null,
      originalFim: null,
      newInicio: null,
      newFim: null,
      loadingActions: false,
    }
  },
  created() {
    this.load();
  },

  methods: {
    /*
    convertToFrontDate(date) {
        return date.replace(/(\-03)$/g, '').replace(/\ /g, 'T')
    },
    convertToBackDate(date) {
        return date.replace(/\T/g, ' ') + '-03'
    },
    */
    load() {
      this.originalInicio = this.inicio.slice(11, -3)
      this.originalFim = this.fim.slice(11, -3)
      this.reverterHorario()
    },
    createDate(dateString) {
      let splittedDate = dateString.split(' ')

      let [year, month, day] = splittedDate[0].split('-')
      let [hour, minute, second] = splittedDate[1].split(':')
      return new Date(year, month, day, hour, minute, second)
    },
    reverterHorario() {
      this.newInicio = this.originalInicio
      this.newFim = this.originalFim
    },
    atualizarHorario() {
      this.loadingActions = true

      let data = {
        anotacaoId: this.aulaId,
        schema: this.schema,
        inicio: this.newInicio,
        fim: this.newFim
      }
      this.$http.post(urlApi + '/dashboard/aulas/praticas/atualizarHorario', data)
        .then(response => {
          if (response.data.success) {
            Vue.toasted.show('Horario de aula atualizado com sucesso', {
              icon: 'fa-info',
              position: 'top-right',
              duration: 5000,
              fullWidth: false
            })

            let aulas = [];
            for (let aula of this.aulas) {
              aulas.push(aula.id_aulas_praticas)
            }
            this.$http.post(urlApi + '/getran/enviar/aula', { aulaId: aulas, schema: this.schema }).finally((response) => {
              this.$emit('update-aulas')
            })
          }

        })
        .finally(() => {
          this.loadingActions = false
        })
    },
    openConfirmMoodal() {
      this.$refs.confirmModal.open()
    },
    cancelarAula() {
      this.$refs.confirmModal.close()

      this.loadingActions = true

      this.$http.post(urlApi + '/dashboard/aulas/praticas/removerAnotacao', { id: this.aulaId, schema: this.schema })
        .then(response => {
          if (response.data.success) {
            this.removerAula(index)
          }
          Vue.toasted.show(response.data.msg, {
            icon: 'fa-info',
            position: 'top-right',
            duration: 5000,
            fullWidth: false
          })
        })
        .finally(() => {
          this.loadingActions = false
        })
    }
  }

}
</script>

<style lang="scss" scoped>
.actions {
  display: flex;
  align-items: center;

  div {
    padding: 0 0.5rem;
    display: flex;
    justify-content: center;

    &:not(:first-child) {
      border-left: 1px solid #ECECEC;
    }

    &:not(:last-child) {
      border-right: 1px solid #ECECEC;
    }
  }
}
</style>